<template>
  <div>
    <the-header />
    <div class="animationFix">
      <slot />
    </div>
    <the-footer />
  </div>
</template>
<script>
import TheHeader from '../components/Common/TheHeader';
import TheFooter from '../components/Common/TheFooter';
export default {
  components: {
    TheHeader,
    TheFooter
  }
}
</script>